import {INotedAuthor} from '../../services/landing-service';

export class AuthorClicked {
	constructor(public author: INotedAuthor) {
	}
}
